// extracted by mini-css-extract-plugin
export var drawerContent = "_3k-0";
export var valueBlock = "_3k-1";
export var valueBlockFrom = "_3k-2 _3k-1";
export var valueBlockTo = "_3k-3 _3k-1";